<template>
  <div class="content-thumb flex-none">
    <img :src="imageURL" alt="" loading="lazy" />
    <slot />
  </div>
</template>

<script>
export default {
  name: "CardImage",
  props: {
    image: {
      validator: prop => typeof prop === 'object' || prop === null,
      required: true
    }
  },

  computed: {
    imageURL() {
      if (!this.image) return

      return this.image.medium
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  &-thumb {
    position: relative;
    overflow: hidden;
    width: 100%;
    padding-top: 50%;
    @apply bg-gray-500;

    @apply rounded;

    img {
      object-fit: cover;
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }

    &__footer {
      position: absolute;
      left: 0;
      bottom: 0;
      background: #7C7C7C;
      @apply text-white;
      @apply text-xs;
      line-height: 1.15;
      @apply py-1;
      @apply px-3;
    }
  }
}
</style>
